import cn from 'clsx'
import React, { FC, ReactNode, useState } from 'react'
import { ChevronDown, ChevronUp } from '@components/icons'
import { useSpring, a } from '@react-spring/web'
import useMeasure from 'react-use-measure'
import s from './VariantCollapse.module.css'

export interface VariantCollapseProps {
  optionType: string
  optionValue: string | undefined
  children: ReactNode
  className?: string
}

const VariantCollapse: FC<VariantCollapseProps> = (props) => {
  const [isActive, setActive] = useState(false)
  const [ref, { height: viewHeight }] = useMeasure()
  const { optionType, optionValue, children, className } = props
  const rootClassName = cn(s.root, className)

  const animProps = useSpring({
    height: isActive ? viewHeight : 0,
    config: { tension: 250, friction: 32, clamp: true },
    opacity: isActive ? 1 : 0,
  })

  const toggle = () => setActive((x) => !x)

  return (
    <div className={rootClassName}>
      <div
        className={cn(s.header, { [s.open]: isActive })}
        role="button"
        tabIndex={0}
        aria-expanded={isActive}
        onClick={toggle}
      >
        <div className="text-sm text-center mx-auto">
          <span className="capitalize">{optionValue || '-'}</span>
        </div>
        <div className="absolute right-4">
          {isActive ? (
            <ChevronUp className={s.icon} />
          ) : (
            <ChevronDown className={s.icon} />
          )}
        </div>
      </div>
      <a.div style={{ overflow: 'hidden', ...animProps }}>
        <div ref={ref} className={s.content} onClick={() => setActive(false)}>
          {children}
        </div>
      </a.div>
    </div>
  )
}

export default React.memo(VariantCollapse)
